/**
 * Mock data for payment methods
 * This simulates data that would come from an API
 */

export const paymentMethods = [
  {
    id: 1,
    accountHolder: "John Doe",
    bankName: "PNC Bank",
    accountNumber: "****5678",
    routingNumber: "****4321",
    accountType: "Checking",
    isPrimary: true,
    status: "active",
    dateAdded: "2024-01-15",
    approvalDate: "2024-01-16",
    expirationDate: "2025-04-16", // 3 months after approval
    lastUpdated: "2024-10-10",
  },
  {
    id: 2,
    accountHolder: "John Doe",
    bankName: "Wells Fargo",
    accountNumber: "****9012",
    routingNumber: "****8765",
    accountType: "Savings",
    isPrimary: false,
    status: "active",
    dateAdded: "2024-02-20",
    approvalDate: "2024-02-22",
    expirationDate: "2025-05-22", // 3 months after approval
    lastUpdated: "2024-10-12",
  },
  {
    id: 3,
    accountHolder: "Jane Doe",
    bankName: "TD Bank",
    accountNumber: "****3456",
    routingNumber: "****2109",
    accountType: "Checking",
    isPrimary: false,
    status: "pending_verification",
    dateAdded: "2024-09-05",
    approvalDate: null,
    expirationDate: null,
    lastUpdated: "2024-10-14",
  },
];

/**
 * Status configuration with display labels and colors (Philadelphia Style Guide)
 */
export const paymentStatusConfig = {
  active: {
    label: "Active",
    color: "#3a833c", // Phanatic Green - Philly Style Guide
    bgColor: "#dcf8d8", // Phanatic Green Light - Philly Style Guide
  },
  pending_verification: {
    label: "Pending Verification",
    color: "#f99300", // Flyers Orange - Philly Style Guide
    bgColor: "#fff7d0", // Bell Yellow Light - Philly Style Guide
  },
  inactive: {
    label: "Inactive",
    color: "#444444", // Dark Gray - Philly Style Guide
    bgColor: "#f0f0f0", // Ghost Gray - Philly Style Guide
  },
  suspended: {
    label: "Suspended",
    color: "#cc3000", // Love Park Red - Philly Style Guide
    bgColor: "#fee7e7", // Love Park Red Light - Philly Style Guide
  },
};

/**
 * Get payment status display information
 * @param {string} statusKey - The status key
 * @returns {object} Status configuration object
 */
export function getPaymentStatusInfo(statusKey) {
  return paymentStatusConfig[statusKey] || {
    label: statusKey,
    color: "#444444",
    bgColor: "#f0f0f0",
  };
}

/**
 * Filter payment methods by search term
 * @param {string} searchTerm - Search term to filter by
 * @returns {array} Filtered payment methods
 */
export function filterPaymentMethods(searchTerm) {
  if (!searchTerm) return paymentMethods;

  const term = searchTerm.toLowerCase();
  return paymentMethods.filter(
    (payment) =>
      payment.accountHolder.toLowerCase().includes(term) ||
      payment.bankName.toLowerCase().includes(term) ||
      payment.accountType.toLowerCase().includes(term) ||
      payment.id.toString().includes(term)
  );
}

/**
 * Get payment method by ID
 * @param {number} id - Payment method ID
 * @returns {object|null} Payment method object or null if not found
 */
export function getPaymentMethodById(id) {
  return paymentMethods.find((payment) => payment.id === id) || null;
}

/**
 * Get primary payment method
 * @returns {object|null} Primary payment method or null if not found
 */
export function getPrimaryPaymentMethod() {
  return paymentMethods.find((payment) => payment.isPrimary) || null;
}

export default paymentMethods;
